import { useEffect } from "react";
import { ArccaNavbar, ArccaFooter } from "../components/arcca/ArccaNav";
import { ArccaHero } from "../components/arcca/ArccaHero";
import { ArccaChange, ArccaThreeRoles, ArccaRollout } from "../components/arcca/ArccaChangeLife";
import { ArccaSteps } from "../components/arcca/ArccaUseCard";
import { ArccaBrdBenefits } from "../components/arcca/ArccaBrdBenefits";
import { ArccaBenefits } from "../components/arcca/ArccaBenefits";

export default function Arcca() {
  useEffect(() => {
    const prev = document.title;
    document.title = "Arcca × BRD-ISIC — Noul tău card de acces";
    return () => {
      document.title = prev;
    };
  }, []);

  return (
    <div className="font-sans text-arccaink bg-white antialiased">
      <ArccaNavbar />
      <main>
        <ArccaHero />
        <ArccaChange />
        <ArccaThreeRoles />
        <ArccaRollout />
        <ArccaSteps />
        <ArccaBenefits />
        <ArccaBrdBenefits />
      </main>
      <ArccaFooter />
    </div>
  );
}
